import React from 'react';
import AuthCheckManager from '../../Utils/AuthCheck/ManagerCheck.auth';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import { FormContainer } from '../../AdminRoutes/CreateRoutes/CreateForm.styles';
import PurchaseHistoryDataProvider from '../../Utils/Companies/PurchaseHistoryDataProvider';
import { useParams } from 'react-router-dom';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import EachPurchaseEntity from './EachPurchase.component';

const PurchaseHistory = () => {
  const { id } = useParams();
  return (
    <AuthCheckManager>
      <HelmetHelper
        title="Purchase History"
        description="Purchase history page for a company"
      />
      <FormContainer>
        <BreadCrumbs
          one="Company Dashboard"
          oneLink="/company"
          two="Purchase History"
        />

        <h2>Purchase History</h2>
        <PurchaseHistoryDataProvider id={id}>
          {(purchaseHistory) => {
            const history = purchaseHistory || [];
            return (
              <div>
                {history?.length > 0 ? (
                  history?.map((purchase, i) => (
                    <EachPurchaseEntity purchase={purchase} key={i} />
                  ))
                ) : (
                  <p>No purchase history available.</p>
                )}
              </div>
            );
          }}
        </PurchaseHistoryDataProvider>
      </FormContainer>
    </AuthCheckManager>
  );
};

export default PurchaseHistory;
